import React from 'react';
import { WorkspaceProvider } from '../domains/workspace/state/WorkspaceProvider';
import { DocumentProvider } from '../domains/document/state/DocumentProvider';

/**
 * AppProviders composes all global context providers for the application.
 * Currently, it includes WorkspaceProvider and DocumentProvider.
 */
export const AppProviders = ({ children }) => {
  return (
    <WorkspaceProvider>
      <DocumentProvider>
        {children}
      </DocumentProvider>
    </WorkspaceProvider>
  );
};

export default AppProviders;
